export default __webpack_public_path__ + "static/tripadvisor_light-2258a6a313f64bbe257f8ba20282b7a8.svg";